import Vue from 'vue';

import address from './common/address.js';
import sms from './common/sms.js';
import Statistics from './common/Statistics.js';

import distribute from './main/distribute.js';
import project from './main/project.js';
import qaedas from './main/qaedas.js';
import token from './main/token.js';
import user from './main/user.js';
import opinion from './main/opinion.js';
import Alarmsetting from './main/Alarmsetting.js';
import Alarm from './main/Alarm.js';
import Msms from './main/Msms.js';
import Smslog from './main/Smslog.js';
import Recharge from './main/Recharge.js';

import abnormal from './lot/abnormal.js';
import devices from './lot/devices.js';
import devicesdata from './lot/devicesdata.js';
import terminal from './lot/terminal.js';
import Aerationoperate from './lot/Aerationoperate.js';
import rfTerminal from './lot/rfTerminal.js';
import Antenna from './lot/Antenna.js';
import Epc from './lot/Epc.js';
import Label from './lot/Label.js';
import Packet from './lot/Packet.js';
import Tactics from './lot/Tactics.js';
import Disinfection from './lot/Disinfection.js';
import Disinfectionalarmlog from './lot/Disinfectionalarmlog.js';
import Disinfectionlog from './lot/Disinfectionlog.js';
import Disinfectionpowerlog from './lot/Disinfectionpowerlog.js';
import Sample from './lot/Sample.js';
import Samplealarmlog from './lot/Samplealarmlog.js';
import Samplelog from './lot/Samplelog.js';
import Devicesinfo from './lot/Devicesinfo.js';
import preferences from './lot/preferences.js';

import vcr from './video/vcr.js';
import video from './video/video.js';
import ysy from './video/ysy.js';
import Screenshot from './video/Screenshot.js';

import eat from './production/eat.js';
import record from './production/record.js';
import rfid from './production/rfid.js';
import species from './production/species.js';
import speciesP from './production/speciesP.js';
import userT from './production/userT.js';
import turnover from './production/turnover.js';
import claim from './production/claim.js';
import ramp from './production/ramp.js';

import archives from './traceability/archives.js';

import Claimrecord from './RL/Claimrecord.js';
import Contract from './RL/Contract.js';
import Fence from './RL/Fence.js';
import Species from './RL/Species.js';
import Speciesdetails from './RL/Speciesdetails.js';
import userR from './RL/user.js';

Vue.prototype.api={};

Vue.use(address);
Vue.use(sms);
Vue.use(Statistics);

Vue.use(distribute);
Vue.use(project);
Vue.use(qaedas);
Vue.use(token);
Vue.use(user);
Vue.use(opinion);
Vue.use(Alarmsetting);
Vue.use(Alarm);
Vue.use(Msms);
Vue.use(Smslog);
Vue.use(Recharge);

Vue.use(abnormal);
Vue.use(devices);
Vue.use(devicesdata);
Vue.use(terminal);
Vue.use(Aerationoperate);
Vue.use(rfTerminal);
Vue.use(Antenna);
Vue.use(Epc);
Vue.use(Label);
Vue.use(Packet);
Vue.use(Tactics);
Vue.use(Disinfection);
Vue.use(Disinfectionalarmlog);
Vue.use(Disinfectionlog);
Vue.use(Disinfectionpowerlog);
Vue.use(Sample);
Vue.use(Samplealarmlog);
Vue.use(Samplelog);
Vue.use(Devicesinfo);
Vue.use(preferences);

Vue.use(vcr);
Vue.use(video);
Vue.use(ysy);
Vue.use(Screenshot);

Vue.use(eat);
Vue.use(record);
Vue.use(rfid);
Vue.use(species);
Vue.use(speciesP);
Vue.use(userT);
Vue.use(turnover);
Vue.use(claim);
Vue.use(ramp);

Vue.use(archives);

Vue.use(Claimrecord);
Vue.use(Contract);
Vue.use(Fence);
Vue.use(Species);
Vue.use(Speciesdetails);
Vue.use(userR);

